<template>
<div>
    <!-- Validation Alerts -->
    <BaseValidationAlerts :context="context" />

    <BaseEditPage
        :context="context+'s'"
        :alvqa="alvqa"
        cancelIconRoute="/publishing/works"
        :defaultOpenPanelsArray="defaultOpenPanels"
    >

<!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div class="d-flex align-center" style="margin-top: 8px;">
                <div :alvqa="alvqa + '-title'" style="display: flex; align-items: center;">
                    {{ $route.params.alvId === 'new' ? $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') :  data.title }}
                </div>
                <div class="ml-2" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                    <ContextHelpIcon 
                        v-if="hasContextHelp && (data.title || $route.params.alvId === 'new')"
                        context="PublishingWorksEdit"
                        :alvqa="alvqa + '-context-help-icon'"
                    />
                </div>
            </div>
        </template>
<!-- EDIT FORM -->
        <template v-slot:editForm>
            <!-- 1st column -->
            <v-col cols="2">
                <v-row>
                    <v-col>
                        <!-- <v-img 
                            v-if="data.pictureBig !== null"
                            :src="data.pictureBig"
                        ></v-img> -->
                        <!--  v-else -->
                        <v-img
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <!-- <BaseIcon 
                                    @click="uploadPicture()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_CAPTION_UPLOAD_IMAGE"
                                />   -->
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col>
            <!-- 2nd column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Title"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE')"
                        :alvqa="alvqa + '-textfield-title'"
                        rules="required"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="DomesticTitle"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_DOMESTIC_WORK_TITLE')"
                        :alvqa="alvqa + '-textfield-domestic-title'"
                    />
                    <v-icon 
                        color="iconStandard"
                        tabindex="-1"
                        small
                        @click="aiIntlTitle"
                    >auto_fix_high
                    </v-icon>
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="ScorePrinting"
                        :items="scorePrintingItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_SCORE_PRINTING')" 
                        :alvqa="alvqa + '-dropdown-score-printing'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Language"
                        :items="languageItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_LANGUAGE')" 
                        :alvqa="alvqa + '-dropdown-language'"
                    />
                </v-row>
                <v-row>
                    <!-- rules="isrc" -->
                    <BaseEditPageTextField 
                        :context="context"
                        field="Isrc"
                        :label="$t('lang_GENERAL_CAPTION_ISRC')"
                        :alvqa="alvqa + '-textfield-isrc'"
                    />
                </v-row>  

                <!-- FreiV free rolesplit definition between Music and Text -->
                <!-- GEMA FreiV is 55% of 64:36: Upper (80,2) and Lower (35,2) Bounds -->
                <!-- TODO_PT: still problem of Komma and Dot when entering / showing values -->
                <v-row class="fill-width">
                    <BaseEditPageTextField 
                        :context="context"
                        field="FreeRoleSplitMusic"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_FREE_ROLESPLIT_MUSIC')"
                        :additionalFunction="calculateFreeRoleSplitText"
                        :iconTooltipText="$t('lang_PUBLISHING_WORKS_TOOLTIP_FREE_ROLESPLIT_MUSIC')"
                        rules="freeRoleSplitMusic"
                        :disabled="getDisabledValue"
                        :alvqa="alvqa + '-textfield-free-rolesplit-music'"
                    />
                    <BaseEditPageTextField 
                        :context="context"
                        field="FreeRoleSplitText"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_FREE_ROLESPLIT_TEXT')"
                        :readonly="true"
                        :disabled="getDisabledValue"
                        :clearable="false"
                        :alvqa="alvqa + '-textfield-free-rolesplit-text'"
                    />
                </v-row> 

                <!-- Notes  -->
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="Notes"
                        :label="$t('lang_GENERAL_CAPTION_NOTES')"
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col>
            <!-- 3rd column  -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_CAPTION_ALVID')" 
                        :readonly="true"
                        :clearable="false"
                        :alvqa="alvqa + '-textfield-alvid'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="SocietyWorkId"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_SOCIETY_WORK_ID')"  
                        :clearable="true"
                        :readonly="false"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-society-work-id'"
                    />
                </v-row>   
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="IceWorkKey"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_ICE_WORK_KEY')"  
                        :clearable="societyWorkIdIsClearable"
                        :readonly="societyWorkIdIsReadonly"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-ice-work-key'"
                    />
                </v-row>  
                <v-row>
                    <!-- rules="iswc" -->
                    <BaseEditPageTextField 
                        :context="context"
                        field="Iswc"
                        :label="$t('lang_GENERIC_CAPTION_ISWC')"
                        :readonly="true"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-iswc'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="CatalogueNumber"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_CATALOGUE_NUMBER')"
                        :alvqa="alvqa + '-textfield-catalogue-number'"
                    />
                </v-row>  

                <!-- <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="PwrDate"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_PWR_DATE')" 
                        :alvqa="alvqa + '-datepicker-pwr-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="PwrDuration"
                        rules="integer"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_PWR_DURATION')"
                        :alvqa="alvqa + '-textarea-foreign-work-ids'"
                    />
                </v-row> -->
            </v-col>
            <!-- 4th column -->
            <v-col cols="2">
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="RegistrationDate"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_REGISTRATION_DATE')"  
                        :disabled="true"
                        :alvqa="alvqa + '-datepicker-registration-date'"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="LastUpdated"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_LAST_UPDATED')"  
                        :disabled="true"
                        :alvqa="alvqa + '-datepicker-last-updated'"
                    />
                </v-row> 
                <!-- rules="duration" -->
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Duration"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_DURATION')"
                        iconTooltipText="hh:mm:ss | mm:ss"
                        
                        :alvqa="alvqa + '-textfield-duration'"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="worksTypes" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_TYPE')" 
                        :alvqa="alvqa + '-dropdown-type'"
                        :clearable="getStatus === 'ghost' ? true : false"
                        :rules="getStatus === 'ghost' ? '' : 'required'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="WorkPoints"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_WORK_POINTS')"
                        :iconTooltipText="$t('lang_PUBLISHING_WORKS_TOOLTIP_WORK_POINTS')"
                        :alvqa="alvqa + '-textfield-work-points'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="NotificationDate"
                        :label="$t('lang_GENERAL_CAPTION_NOTIFICATION_DATE')"
                        :alvqa="alvqa + '-datepicker-notification-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="LeadingPublisher"
                        :items="leadingPublisherItems" 
                        :label="$t('lang_PUBLISHING_WORK_LEADING_PUBLISHER')" 
                        :alvqa="alvqa + 'dropdown-leading-publisher'"
                    />
                </v-row>
            </v-col>
            <!--  5th column -->
            <v-col cols="2">
                 <v-row>
                    <BaseEditPageDropdown
                        :context="context"
                        field="Status"
                        :items="statusItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_STATUS')" 
                        :disabled="statusDropdownDisabled"
                        :clearable="false"
                        :alvqa="alvqa + 'dropdown-status'"
                        rules="required"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="IceStatus"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_ICE_STATUS')"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-ice-status'"
                    />
                </v-row> 
                <v-row> 
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Style"
                        :items="styleItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_STYLE')" 
                        :alvqa="alvqa + 'dropdown-style'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="BackCollection"
                        :items="backCollectionItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_BACK_COLLECTION')" 
                        :alvqa="alvqa + 'dropdown-back-collection'"
                        :clearable="getStatus === 'ghost' ? true : false"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="OldMrSplit"
                        :items="oldMrSplitItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_OLD_MR_SPLIT')" 
                        :alvqa="alvqa + 'dropdown-old-mr-split'"
                        :clearable="getStatus === 'ghost' ? true : false"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Tags"
                        :label="$t('lang_GENERIC_CAPTION_TAGS')"
                        :iconTooltipText="$t('lang_GENERAL_INFO_MESSAGE_WHITE_SPACE_SEPARATED')"
                        :alvqa="alvqa + '-textfield-tags'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Favourites"
                        :items="getDropdownYesNo" 
                        :label="$t('lang_GENERAL_FAVOURITE')" 
                        :alvqa="alvqa + 'dropdown-favourites'"
                        :clearable="false"
                    />
                </v-row>
            </v-col>
        </template>
<!-- PANELS -->
        <template v-slot:panels>
            <DeletionDialog :useContextSetinVuex="true" />

            <!-- ORIGINAL SHARES Panel -->
            <!-- TODO: Check what if $route.params.alvId == new? -->
            <OriginalSharesEditPanel 
                v-for="shareType of getShareTypes"
                v-bind:key="shareType"
                    :originalShares="getOriginalShares[shareType]"
                    :typeName="shareType"
            />
            <OriginalSharesEditPanelDialog />

            <!-- INSTRUMENTATION -->
            <InstrumentationEditPanel />
            <InstrumentationEditPanelDialog />

            <!-- ALTERNATIVE TITLES -->
            <AlternativeTitlesEditPanel />
            <AlternativeTitlesEditPanelDialog />
            
            <!-- OTHER PERSONS -->
            <OtherPersonsEditPanel />
            <OtherPersonsEditPanelDialog />

            <!-- OTHER IDS -->
            <OtherIdsEditPanel />
            <OtherIdsEditPanelDialog />
        </template>
    </BaseEditPage>
    
    <!-- Context Help Dialog -->
    <ContextHelpDialog />

    <!-- Title Assist Dialog -->
    <WorksTitleAssistDialog :alvqa="alvqa" @apply="applyTitleAssist" />
    </div>
</template>

<script>
import {    
        DropdownPublishingWorksStatus, 
        DropdownPublishingWorksOldMrSplit,
        DropdownPublishingWorksTypes, 
        DropdownGenericYesNo
    } 
from '@/assets/dropdowns/alvDropdowns.js'

import BaseEditPage from '@/components/_base/BaseEditPage' 
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseValidationAlerts from '@/components/_base/BaseValidationAlerts'

import AlternativeTitlesEditPanel from './_panels/3_othertitles/AlternativeTitlesEditPanel'
import OtherPersonsEditPanel from './_panels/4_otherpersons/OtherPersonsEditPanel'
import OtherPersonsEditPanelDialog from './_panels/4_otherpersons/OtherPersonsEditPanelDialog'
import OtherIdsEditPanel from './_panels/5_otherids/OtherIdsEditPanel'
import OtherIdsEditPanelDialog from './_panels/5_otherids/OtherIdsEditPanelDialog'
import OriginalSharesEditPanel from './_panels/1_originalshares/OriginalSharesEditPanel'

import AlternativeTitlesEditPanelDialog from './_panels/3_othertitles/AlternativeTitlesEditPanelDialog'
import InstrumentationEditPanel from '@/pages/2_publishing/1_works/_edit/_panels/2_instrumentation/InstrumentationEditPanel'
import InstrumentationEditPanelDialog from '@/pages/2_publishing/1_works/_edit/_panels/2_instrumentation/InstrumentationEditPanelDialog'
import OriginalSharesEditPanelDialog from './_panels/1_originalshares/OriginalSharesEditPanelDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'
import WorksTitleAssistDialog from '@/pages/2_publishing/1_works/_dialogs/WorksTitleAssistDialog'

export default {
    name: "WorksEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageTextarea,
        BaseEditPageDatePicker,
        BaseValidationAlerts,

        AlternativeTitlesEditPanel,
        OtherPersonsEditPanel,
        OriginalSharesEditPanel,

        AlternativeTitlesEditPanelDialog,
        InstrumentationEditPanel,
        InstrumentationEditPanelDialog,
        OtherPersonsEditPanelDialog,
        OriginalSharesEditPanelDialog,
        DeletionDialog,
        OtherIdsEditPanel,
        OtherIdsEditPanelDialog,
        ContextHelpIcon,
        ContextHelpDialog,
        WorksTitleAssistDialog,
    },
    data() {
        return {
            context: "Work",
            statusDropdownDisabled: false,
            alvqa: "publishing-works-edit-form",
            hasContextHelp: false
        }
    },
    computed: {
        validationMessages() {
            return this.$store.getters.getValidationMessages
        },
        titleAssistOptions() {
            const s = this.$store.getters.getWorksTitleAssistSuggestions || {}
            const list = []
            if (Array.isArray(s.literal)) list.push.apply(list, s.literal)
            if (s.romaji) list.push(s.romaji)
            if (Array.isArray(s.transcreation)) list.push.apply(list, s.transcreation)
            const seen = {}
            const uniq = []
            for (let v of list) {
                if (!v) continue
                const key = String(v).toLowerCase().trim()
                if (!seen[key]) { seen[key] = true; uniq.push({ text: String(v).trim() }) }
            }
            return uniq
        },
        countPerRole() {
            let roleMap = {}
            let values = this.getOriginalShares
            // TODO: Check if it is needed to count across all share types or is it on shareType scope
            for (const shareType of Object.keys(values)) {
                for (const value of values[shareType]) {
                    if(value.role in roleMap) {
                        roleMap[value.role] += 1
                    } else {
                        roleMap[value.role] = 1
                    }
                }
            }

            return roleMap
        },
        getDisabledValue() { 
            let disabledStatus = true
            let countPerRole = this.countPerRole
            let countA = countPerRole['A'] || 0
            let countC = countPerRole['C'] || 0 

            if(countA > 0 && countC > 0) { 
                    disabledStatus = false 
            }

                 
            return disabledStatus
        },

        getStatus() { return this.$store.getters.getWorkDetailsStatus },

        // Define if socitey work id is readonly and/or clearable
        societyWorkIdIsReadonly() { 
            let isReadonly = true
            if(this.getStatus === 'ghost' || this.getStatus === null) isReadonly = false
            return isReadonly
        },
        societyWorkIdIsClearable() { 
            let isClearable = false
            if(this.getStatus === 'ghost' || this.getStatus === null) isClearable = true
            return isClearable
        },

        // Dropdown Items

        // Set status items, depending on the currently selected Status the Dropdown changes
        statusItems() { 
            let allPossibleStatus = DropdownPublishingWorksStatus

            allPossibleStatus.sort((a,b) => (this.$t(a.text) > this.$t(b.text)) ? 1 : (this.$t(b.text) > this.$t(a.text)) ? -1 : 0)

            return allPossibleStatus
        },

        languageItems() { return this.$alvPlugin.getListOfTranslatedLanguages() },

        leadingPublisherItems() { 
            let publisherArr
            let publishers = this.$store.getters.getLeadingPublishers
            
            // Set alvqa
            if(publishers !== undefined) {
                publisherArr = JSON.parse(JSON.stringify(publishers))
                publisherArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-download-leading-publisher-' + element.value
                })
            } else {
                publisherArr = []
            }

            return publisherArr
        },

        styleItems() { 
            let styleArr
            let styles = this.$store.getters['getWorkStyles'][this.$i18n.locale]

            // Set alvqa
            if(styles !== undefined) {
                styleArr = JSON.parse(JSON.stringify(styles))
                styleArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-style-' + element.value.toLowerCase().replace(/ /g,"_")
                });
            } else {
                styleArr = []
            }
            return styleArr
        },

        scorePrintingItems() {
            return [ 
                {
                    text: this.$t('lang_PUBLISHING_WORKS_SCORE_PRINTING_DROPDOWN_OPTION_SPD_AVAILABLE'), 
                    value: 'spdAvailable',
                    alvqa: this.alvqa + '-dropdown-score-printing-spd-available'
                }, 
                {
                    text: this.$t('lang_PUBLISHING_WORKS_SCORE_PRINTING_DROPDOWN_OPTION_NO_SPD_AVAILABLE'), 
                    value: 'spdNotAvailable',
                    alvqa: this.alvqa + '-dropdown-score-printing-spd-not-available'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_SCORE_PRINTING_DROPDOWN_OPTION_PRINTING_INTENDED'), 
                    value: 'intended',
                    alvqa: this.alvqa + '-dropdown-score-printing-intended'
                },
            ]
        },
        getOriginalShares() {
            let val = this.$store.getters.getWorksOriginalShares
            if (typeof val == 'object') {
                for (let shareType of this.getShareTypes) {
                    if (!(shareType in val)) {
                        val[shareType] = []
                    }
                }
            }
            return val
        },
        
        backCollectionItems() { return DropdownGenericYesNo },
        oldMrSplitItems() { return DropdownPublishingWorksOldMrSplit },
        getDropdownYesNo() { return DropdownGenericYesNo },
        worksTypes() { return DropdownPublishingWorksTypes },
        getShareTypes() { return ['manu', 'role', 'intl', 'own'] },
        defaultOpenPanels() {
            return [];
        },
    },

    methods: {
        clearMessages() {
            this.$store.commit('clearValidationMessagesWork')
        },
        async aiIntlTitle() {
            document.activeElement.blur();
            try {
                const domesticTitle = this.$store.getters.getWorkDetailsDomesticTitle
                if(!domesticTitle || domesticTitle.trim() === '') { 
                    this.$store.commit('setSnackbar', { type: 'error', msg: this.$t('lang_GENERIC_MESSAGE_AI_ERROR_EMPTY_INPUT') })
                    return 
                }
                
                // Frontend validation - check for Japanese or Korean characters
                const hasHiragana = /[\u3040-\u309F]/.test(domesticTitle)
                const hasKatakana = /[\u30A0-\u30FF]/.test(domesticTitle)
                const hasKanji = /[\u4E00-\u9FAF]/.test(domesticTitle)
                const hasHangul = /[\uAC00-\uD7AF\u1100-\u11FF]/.test(domesticTitle)
                
                if (!hasHiragana && !hasKatakana && !hasKanji && !hasHangul) {
                    this.$store.commit('setSnackbar', { type: 'error', msg: this.$t('lang_GENERIC_MESSAGE_AI_ERROR_JAPANESE_KOREAN_ONLY') })
                    return
                }
                
                const res = await this.$store.dispatch('fetchAiIntlTitleSuggestions', domesticTitle)
                if (res && res.error && res.errorMsg) {
                    this.$store.commit('setSnackbar', { type: 'error', msg: res.errorMsg })
                }
            } catch (e) { /* swallow */ }
        },
        onSelectTitle(val) {
            if (val) this.$store.commit('setWorksTitleAssistDraft', val)
        },
        applyTitleAssist() {
            const draft = this.$store.getters.getWorksTitleAssistDraft
            if(draft && draft.trim() !== '') {
                this.$store.commit('setWorkDetailsTitle', draft.trim())
            }
            // Clear dialog state on Apply
            this.$store.commit('setWorksTitleAssistDialogDetails', { titleAssistDraft: '', titleAssistSelection: null })
            this.$store.commit('setWorksTitleAssistSuggestions', { literal: [], romaji: '', transcreation: [] })
            this.$store.commit('setWorksTitleAssistLoading', false)
            this.$store.commit('setWorksTitleAssistDialog', false)
        },
        calculateFreeRoleSplitText() {
            let freiVM = this.$store.getters.getWorkDetailsFreeRoleSplitMusic
            const isGermanLang = this.$i18n.locale === 'de'
            if (freiVM && isGermanLang) {
              freiVM = freiVM.toString().replace(',', '.')
            }
            if (freiVM == null || freiVM < 35.2 || freiVM > 80.2) {
                this.$store.commit('setWorkDetailsFreeRoleSplitText', null)
            } else {
                let freiVT = (100.00-freiVM).toFixed(2)
                freiVT = isGermanLang ? freiVT.toString().replace('.', ',') : freiVT.toString().replace(',', '.')
                this.$store.commit('setWorkDetailsFreeRoleSplitText', freiVT)
            }
        },
        
        },

    async created() {
        this.$store.commit('setLanguages')
        this.$store.commit('setWorkStyles')
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('PublishingWorksEdit')

        // Reset freiV
        let countPerRole = this.countPerRole
        let countA = countPerRole['A'] || 0
        let countC = countPerRole['C'] || 0
        if(!(countA == 0 || countC == 0)) {
            this.$store.commit("setWorkDetailsFreeRoleSplitMusic",null)
            this.$store.commit("setWorkDetailsFreeRoleSplitText",null)
        }
    },

    watch: {
        '$i18n.locale': {
            handler(newLocale, oldLocale) {
                const convertDecimalSeparator = (value) => {
                    if (value) {
                        return newLocale === 'de' ? value.toString().replace('.', ',') : value.toString().replace(',', '.');
                    }
                    return value;
                };

                const value = convertDecimalSeparator(this.$store.state.works.workDetails.freeRoleSplitMusic);
                const text = convertDecimalSeparator(this.$store.state.works.workDetails.freeRoleSplitText);

                this.$store.commit("setWorkDetailsFreeRoleSplitMusic", value);
                this.$store.commit("setWorkDetailsFreeRoleSplitText", text);
            },
            immediate: true
        }
  },
  beforeRouteLeave(to, from, next) {
        // Clear validation messages when leaving the route
        this.$store.commit("clearValidationMessagesWork");
        next(); // Allow navigation
    },
}
</script>

<style scoped>
    .v-image.defaultImageEditPage {
        background-color: #eeeeee !important;
    }
    
    .v-image.defaultImageEditPage .v-responsive__content {
        background-color: #eeeeee !important;
    }
    
    .fill-width {
        overflow-x: auto;
        flex-wrap: nowrap;
    }

    /* Container for Alerts */
    .alert-container {
        position: fixed;
        top: 10px; /* Adjust to move it below the header */
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999; /* Ensure alerts appear above everything else */
        width: 90%; /* Limit the width */
        max-width: 650px; /* Prevent alerts from becoming too wide */
    }
    /* Animation for alerts */
    .fade-in-alert {
        animation: fadeIn 1s ease-in-out forwards; /* Extend fade-in to 1 second */
        opacity: 0; /* Ensure it starts invisible */
    }

    /* Keyframes for fade-in effect */
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-10px); /* Slightly offset upwards */
        }
        to {
            opacity: 1;
            transform: translateY(0); /* Original position */
        }
    }
</style>